import React from "react";
import ReactDOM from "react-dom";

// Suppress errors thrown by browser extensions (e.g. MetaMask) so they don't
// break the React error overlay on pages that don't use any wallet integration.
window.addEventListener('error', (event) => {
  if (event.filename && event.filename.startsWith('chrome-extension://')) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
});
window.addEventListener('unhandledrejection', (event) => {
  const stack = event.reason?.stack ?? '';
  const msg = event.reason?.message ?? '';
  if (stack.includes('chrome-extension://') || msg.toLowerCase().includes('metamask')) {
    event.preventDefault();
  }
});
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import theme from "assets/theme";
import App from "./App";
import store from "store";
import reportWebVitals from "reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import TourWrapper from "components/TourWrapper";

const persistor = persistStore(store);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <StyledEngineProvider injectFirst>
            <CssBaseline />
            <Router>
              <TourWrapper>
                <App />
              </TourWrapper>
            </Router>
          </StyledEngineProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
